import * as React from 'react'

import { Separator } from '@thg-commerce/gravity-elements'
import { Routes } from '@thg-commerce/enterprise-core'
import { Widget } from '@thg-commerce/enterprise-network/src/generated/graphql'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Basket/theme'

import {
  Container,
  BasketIcon,
  Heading,
  Title,
  Subtitle,
  ContinueShoppingLink,
  ContentWrapper,
} from './styles'
import { WidgetRenderer } from '@thg-commerce/enterprise-widgets'

interface BasketEmptyProps {
  i18nText: {
    heading: string
    title: string
    subtitle: string
    continueShopping: string
  }
  widgets?: Omit<Widget, 'query'>[]
}

export const Empty = ({ i18nText, widgets }: BasketEmptyProps) => {
  const theme = useTheme()
  const showHeading = theme.pageTheme.empty.content?.heading?.show ?? false
  const showSubTitle = theme.pageTheme.empty.content?.subtitle?.show ?? true

  return (
    <Container>
      <ContentWrapper>
        {showHeading && (
          <React.Fragment>
            <Heading>{i18nText.heading}</Heading>
            <Separator
              withSpacing
              separatorMargin={{ top: 4, right: 0, bottom: 32, left: 0 }}
            />
          </React.Fragment>
        )}
        <BasketIcon />
        <Title
          titleMargin={
            theme.pageTheme.empty.content?.title?.margin ?? {
              top: 2,
              right: 0,
              bottom: 2,
              left: 0,
            }
          }
        >
          {i18nText.title}
        </Title>
        {showSubTitle && <Subtitle>{i18nText.subtitle}</Subtitle>}
        <ContinueShoppingLink
          href={Routes.HomePage}
          ariaLabel={i18nText.continueShopping}
          renderedAs="a"
        >
          {i18nText.continueShopping}
        </ContinueShoppingLink>
      </ContentWrapper>
      <WidgetRenderer widgets={widgets || []} path={Routes.Basket} />
    </Container>
  )
}
